<template>
  <div
    v-if="product.active"
  >
    <q-card
      class="cursor-pointer full-height"
      @click="$router.push({
        name: 'ViewProduct',
        params: {
          categoryId: productModel.categoryId,
          productId: productModel.id
        }
      })"
    >
      <div>
        <q-img
          v-if="productModel.hasImages()"
          :src="productModel.getCoverImage().src"
          :srcset="productModel.getCoverImage().srcset"
          :ratio="4/3"
          height="230px"
        />
        <q-img
          v-else
          src="../../../public/logo.svg"
          contain
          :ratio="4/3"
        />
      </div>

      <div class="q-pa-lg">
        <div class="text-h5 text-uppercase text-center text-weight-bold q-mb-md">
          {{ productModel.getTitle() }}
        </div>
        <div class="text-body1">
          {{ productModel.getShortDescription() }}
        </div>
        <div
          class="q-card__price text-h5 text-secondary
          text-center text-weight-bold q-mb-lg"
        >
          <q-separator
            class="q-mt-lg q-mb-xs"
          />
          {{ formatPriceISK(productModel.totalPrice) }}
        </div>
      </div>
    </q-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import LocationModel from 'quasar-pilot-core/src/lib/models/location';
import ProductModel from 'quasar-pilot-core/src/lib/models/product';
import priceFormatter from 'quasar-pilot-core/src/mixins/format/price';
import vuexUtils from 'quasar-pilot-core/src/mixins/util/vuex';
import errorDialog from 'quasar-pilot-core/src/mixins/errorDialog';

export default {
  name: 'FrontProductCard',
  mixins: [priceFormatter, vuexUtils, errorDialog],
  props: {
    product: {
      type: Object,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      productModel: null,
    };
  },
  computed: {
    ...mapState('application', ['defaultDeliveryMethod']),
    ...mapState('location', { currentLocation: 'current' }),
    isOpen() {
      const location = new LocationModel(this.currentLocation);
      return location.isOpen(this.defaultDeliveryMethod.id);
    },
  },

  created() {
    this.productModel = new ProductModel(this.product);
  },
};
</script>

<style lang="scss" scoped>
.q-card {
  box-shadow: 0 12px 15px 0 #0000001A;
  border-radius: 10px;
  padding-bottom: 73px;
  @media (min-width: $breakpoint-lg-min) {
    max-width: 345px;
  }
  @media (min-width: $breakpoint-sm-min) {
    height: 490px;
  }

  &__price {
    @media (min-width: $breakpoint-sm-min) {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }
    @media (max-width: $breakpoint-sm-max) {
      margin-bottom: 0;
      margin-top: 24px;
    }
  }
  .q-separator {
    width: 37px;
    height: 2px;
    background: $primary;
    justify-self: center;
  }
}
.q-img {
  ::v-deep .q-img__image {
    background-size: contain!important;
    border-radius: 6px;
  }
}
</style>
